var React = require('react');

function IconPhone (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"none","d":"M0 0H24V24H0z","key":0}),React.createElement("path",{"fill":"#9e9e9e","d":"M16.308 1H7.692A2.711 2.711 0 0 0 5 3.727v18.546A2.711 2.711 0 0 0 7.692 25h8.615A2.711 2.711 0 0 0 19 22.273V3.727A2.711 2.711 0 0 0 16.308 1zM12 23.909a1.636 1.636 0 1 1 1.615-1.636A1.624 1.624 0 0 1 12 23.909zm4.846-4.364H7.154V4.273h9.692z","transform":"translate(0 -1)","key":1})]);
}

IconPhone.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconPhone;

IconPhone.default = IconPhone;
